import React, { useRef, useState } from "react";
import { useAppContext } from "./App";
import { useNavigate } from "react-router-dom";
import { SPACES } from "./libs/miscLib";
import pinkBlob from './assets/pink-blob.png';
import './BrandHomeMenu.css';
import { FaDelicious } from "react-icons/fa6";
import { FaTools } from "react-icons/fa";


export default function BrandHomeMenu({
  currentSpace,
}) {

  const navigate = useNavigate();
  const { isAuthenticated, splashNavIsHidden } = useAppContext();

  const constructHref = isAuthenticated ? '/construct/f' : '/construct/scratch';

  const [open, setOpen] = useState(false);
  const hoverTimer = useRef(null);

  const startHover = () => {
    hoverTimer.current = setTimeout(() => setOpen(true), 160);
  };

  const endHover = () => {
    clearTimeout(hoverTimer.current);
    setOpen(false);
  };

  return (
    <div
      className={'brand-wrapper ' + (currentSpace === SPACES.SPLASH && splashNavIsHidden ? 'fade-invisible' : 'fade-visible')}
      onMouseEnter={startHover}
      onMouseLeave={endHover}
      onFocus={startHover}
      onBlur={endHover}
      aria-haspopup="menu"
    >
      {/* Main brand link: user clicks to go to Crossworthy Splash page */}
      <a href="/" onClick={e => {
        if (e.button !== 0) return;
        e.preventDefault();
        navigate('/');
      }}>

        {currentSpace === SPACES.SPLASH ? (
          <div className="zoomable clickable">
            <img
              style={{ position: 'fixed', top: '-40px', left: '-40px' }}
              width={170}
              src={pinkBlob}
              alt='pink-blob'
            />
            <img
              style={{ position: 'fixed', top: 14, left: 14 }}
              width={72}
              src='/android-chrome-256x256.png'
              alt='Crossworthy Home'
            />
          </div>
        ) : (
          <div className="zoomable clickable">
            <div
              className={currentSpace === SPACES.CONSTRUCT ? 'purple-3-bkgd' : 'teal-3-bkgd'}
              style={{ position: 'fixed', top: '-10px', left: '-10px', height: '70px', width: '70px', borderRadius: '50%', boxShadow: '0 0 5px #301934' }}
            />
            <img
              style={{ position: 'fixed', top: '0', left: '0' }}
              width={54}
              src='/android-chrome-256x256.png'
              alt='Crossworthy Home'
            />
          </div>
        )}
      </a>

      {/* Flyout menu */}
      <div className={`brand-flyout ${open && currentSpace !== SPACES.SPLASH ? 'open' : ''}`}>
        <a
          className='pt-2 zoomable-subtle clickable'
          style={{textDecoration: 'none'}}
          href={constructHref}
          onClick={e => {
            e.preventDefault();
            e.stopPropagation();
            clearTimeout(hoverTimer.current);
            navigate(constructHref);
            // setTimeout(() => setOpen(false), 100);
          }}
        >
          <div
            className='flyout-button d-flex align-items-center gap-2 purple-2-bkgd px-3 py-2'
          ><FaTools /><span>Constructor Home</span></div>
        </a>

        <a
          className='pt-2 zoomable-subtle clickable'
          style={{textDecoration: 'none'}}
          href="/collections/crossworthy"
          onClick={e => {
            console.log('clicked')
            e.preventDefault();
            e.stopPropagation();
            clearTimeout(hoverTimer.current);
            navigate("/collections/crossworthy");
            // setTimeout(() => setOpen(false), 100);
          }}
        >
          <div
            className='flyout-button d-flex align-items-center gap-2 teal-2-bkgd px-3 py-2'
          ><FaDelicious /><span>Player Home</span></div>
        </a>
      </div>
    </div>
  )


}